import { useVisible } from 'src/hooks';
import { useContext, useEffect } from 'react';
import ThreadInputBoxContext from 'src/contexts/ThreadInputBoxContext';

type SuccessMessageWithTimerProps = {
  className?: string;
};

export const SuccessMessageWithTimer = ({
  className,
}: SuccessMessageWithTimerProps) => {
  const { isVisible, onVisibilityRemove } = useVisible(true);
  const { threadInputBoxFiles } = useContext(ThreadInputBoxContext);

  useEffect(() => {
    const timer = setTimeout(() => {
      onVisibilityRemove();
    }, 2000);

    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={className}>
      <span>
        Completed processing {Object.keys(threadInputBoxFiles || {}).length}{' '}
        attachment(s)
      </span>
    </div>
  );
};
